<div *ngIf="canDeleteSupplier">
    <button class="btn btn-danger" [ngClass]="btnClass" (click)="deleteSupplier()" [disabled]="btnDisabled" data-toggle="tooltip" title="Supprimer définitivement le dossier fournisseur">
        <i class="fas fa-skull-crossbones"></i>
    </button>
</div>